import { Component, Input, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { Administrator, blockout_availability, BookingOfficer, Interpreter, UserFactory } from '../../../shared/model/user.entity';
import { FormGroup, FormControl } from '@angular/forms';
import { SpinnerService } from '../../../spinner/spinner.service';
import { NotificationServiceBus } from '../../../notification/notification.service';
import { UserService } from '../../../api/user.service';
import { GLOBAL, ModalOptions } from '../../../shared/global';
import { ActivatedRoute, Router } from '@angular/router';
import { AvailabilityBlock } from '../../../shared/model/availability-block.entity';
import { AuthGuard } from '../../../auth/auth.guard';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { PopupComponent } from '../../../shared/popup/popup.component';
import { ROLE } from '../../../shared/model/role.enum';
import * as momentTimeZone from 'moment-timezone';
import { Booking } from '../../../shared/model/booking.entity';
import { Location } from '@angular/common';
import { forEach } from '@angular/router/src/utils/collection';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';

@Component({
    selector: 'app-blockout',
    templateUrl: './blockout.component.html',
    styleUrls: ['./blockout.component.css']
})
export class BlockoutComponent implements OnDestroy, OnInit {
    sub;
    interpreter: Interpreter;
    param_id: number = -1;
    start_time: Date = new Date();
    end_time: Date = new Date();
    end_date: Date = this.start_time;
    public availabilityBlock: AvailabilityBlock = new AvailabilityBlock();
    dialogRef: MdDialogRef<any>;
    dialogSub;
    userID;
    queryParamSub;
    defaultDateTime: Date;
    public href;
    staff_availability;
    bookingDate: Date;
    sideToggleCheck = false;
    dummy_time;
    repeat_days = [
        {
            sendValue: '0',
            display: 'S',
            value: 'Sunday',
            selected: false
        },
        {
            sendValue: '1',
            display: 'M',
            value: 'Monday',
            selected: false
        },
        {
            sendValue: '2',
            display: 'T',
            value: 'Tuesday',
            selected: false
        },
        {
            sendValue: '3',
            display: 'W',
            value: 'Wednesday',
            selected: false
        },
        {
            sendValue: '4',
            display: 'T',
            value: 'Thursday',
            selected: false
        },
        {
            sendValue: '5',
            display: 'F',
            value: 'Friday',
            selected: false
        },
        {
            sendValue: '6',
            display: 'S',
            value: 'Saturday',
            selected: false
        }
    ];
    isWeekely;
    constructor(public userDataService: UserService,
        public notificationServiceBus: NotificationServiceBus,
        public spinnerService: SpinnerService,
        private route: ActivatedRoute,
        private router: Router,
        public dialog: MdDialog,
        private datePipe: DatePipe,
        public viewContainerRef: ViewContainerRef, private _location: Location) {
    }
    public isRecurrenceDayCheckboxDisabled(day) {
        return this.bookingDate && this.bookingDate.getDay() === this.repeat_days.indexOf(day);
    }
    isTimeEqual() {
        return Boolean(this.start_time) && Boolean(this.end_time) && this.start_time.getTime() === this.end_time.getTime();
    }
    ngOnInit() {
        this.staff_availability = false;
        this.href = this.router.url.split('/');
        if (this.href[3] === 'staff-availability') {
            this.staff_availability = true;
        }

        this.userID = localStorage.getItem('userId');
        if (this.userID > 0) {
            this.spinnerService.requestInProcess(true);
            this.userDataService.getUser(this.userID)
                .subscribe((res: any) => {
                    if (res.status === 200) {
                        delete res.data.assignments_attributes;
                        this.interpreter = <Interpreter>res.data;
                        this.userID = Boolean(this.interpreter) ? this.interpreter.id : -1;
                        this.end_time.setTime(this.start_time.getTime() + (1 * 60 * 60 * 1000));
                        this.end_date = this.end_time;
                        this.sub = this.route.params.subscribe(params => {
                            let param_id = params['id'] || '';
                            if (Boolean(param_id) && parseInt(param_id, 10) > 0) {
                                this.param_id = parseInt(param_id, 10);
                                if (this.staff_availability) {
                                    this.interpreter.staff_availabilities_attributes
                                        .filter(a => a.id === this.param_id)
                                        .map(a =>
                                            this.availabilityBlock = a
                                        );
                                } else {
                                    this.interpreter.availability_blocks_attributes
                                        .filter(a => a.id === this.param_id)
                                        .map(a =>
                                            this.availabilityBlock = a
                                        );
                                }
                                this.sideToggleCheck = this.availabilityBlock.recurring;
                                for (let day of this.availabilityBlock.recurring_week_days) {
                                    this.repeat_days[day].selected = true;
                                }
                                this.availabilityBlock.end_date = this.interpreterStateDateZone(this.availabilityBlock.end_date);
                                this.availabilityBlock.start_time = this.interpreterStateDateZone(this.availabilityBlock.start_time);
                                this.checkIsWeekely();
                                this.settingTime();
                            }
                        });
                        this.roundOffMinutes();
                    }
                    this.spinnerService.requestInProcess(false);
                });
        }
    }
    public setRecurring_week_days() {
        this.availabilityBlock.recurring_week_days = [];
        for (let i = 0; i < this.repeat_days.length; i++) {
            if (this.repeat_days[i].selected) {
                this.availabilityBlock.recurring_week_days.push(this.repeat_days[i].sendValue);
            }
        }
    }
    checkIsWeekely() {
        this.isWeekely = false;
        if (this.availabilityBlock.frequency === 'weekly') {
            this.isWeekely = true;
        }
    }
    ngOnDestroy() {
        return this.sub && this.sub.unsubscribe();
    }
    createModal(title: string, message: string, options?: ModalOptions) {
        let config: MdDialogConfig = {
            disableClose: true
        };
        config.viewContainerRef = this.viewContainerRef;
        this.dialogRef = this.dialog.open(PopupComponent, config);
        this.dialogRef.componentInstance.title = title;
        this.dialogRef.componentInstance.cancelTitle = (options && options.cancelTitle) || 'BACK';
        this.dialogRef.componentInstance.okTitle = (options && options.okTitle) || 'DELETE';
        this.dialogRef.componentInstance.popupMessage = message;

    }
    onStartTimeChanged() {
        this.assignMe('startTimeControl', 0);

        let dt = new Date();
        dt.setDate(this.start_time.getDate());

        dt.setTime(this.start_time.getTime() + (1 * 60 * 60 * 1000));
        this.end_time = dt;
    }
    roundOffMinutes() {
        let dt = this.end_time;
        let currentDate = this.start_time;
        this.defaultDateTime = currentDate;
        let minute = Math.ceil(currentDate.getMinutes() / 5) * 5;
        this.defaultDateTime.setMinutes(minute);
        this.start_time = this.defaultDateTime;
        let end_minute = Math.ceil(dt.getMinutes() / 5) * 5;
        this.end_time.setMinutes(end_minute);
    }
    setDayMonthYear() {
        this.end_time = new Date(this.start_time.getFullYear(), this.start_time.getMonth(), this.start_time.getDate(),
            this.end_time.getHours(), this.end_time.getMinutes());
    }
    getRoute() {
        this._location.back();
    }
    deleteBlockout() {
        let message = `Do you really want to delete this blockout?`;
        let title = 'Delete Blockouts';
        this.createModal(title, message);
        this.dialogSub = this.dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.spinnerService.requestInProcess(true);
                if (this.staff_availability) {
                    this.deleteStaffAvailabilities();
                } else {
                    this.userDataService.deleteBlockout(this.userID, this.availabilityBlock.id)
                        .subscribe((res: any) => {
                            if (res.status === 204) {
                                // UI Notification
                                let idx = this.interpreter.availability_blocks_attributes.indexOf(this.availabilityBlock);
                                this.interpreter.availability_blocks_attributes.splice(idx, 1);
                                this.availabilityBlock = new AvailabilityBlock();
                                this.param_id = -1;
                                this.spinnerService.requestInProcess(false);
                                this.notificationServiceBus.launchNotification(false, 'Blockout successfully deleted');
                                this._location.back();
                            }
                        }, errors => {
                            this.spinnerService.requestInProcess(false);
                            let e = errors.json();
                            this.notificationServiceBus.launchNotification(true, e);
                        });
                }
            }
        });
    }
    deleteStaffAvailabilities() {
        this.userDataService.deleteStaffAvailabilities(this.userID, this.availabilityBlock.id)
            .subscribe((res: any) => {
                if (res.status === 204) {
                    // UI Notification
                    let idx = this.interpreter.staff_availabilities_attributes.indexOf(this.availabilityBlock);
                    this.interpreter.staff_availabilities_attributes.splice(idx, 1);
                    this.availabilityBlock = new AvailabilityBlock();
                    this.param_id = -1;
                    this.spinnerService.requestInProcess(false);
                    this.notificationServiceBus.launchNotification(false, 'Staff Availability successfully deleted');
                    this._location.back();
                }
            }, errors => {
                this.spinnerService.requestInProcess(false);
                let e = errors.json();
                this.notificationServiceBus.launchNotification(true, e);
            });
    }
    interpreterStateTimeZone(time) {
        let timeZone = Booking.getNamedTimeZone(this.interpreter.address_attributes.state, this.interpreter.address_attributes.post_code.toString());
        return momentTimeZone(time).tz(timeZone).format('HH:mm:ss');
    }
    editBlockouts(form: FormGroup) {
        if (form.invalid) {
            this.notificationServiceBus.launchNotification(true, GLOBAL.MISSING_FIELDS_ERROR_MESSAGE);
            return;
        }
        this.spinnerService.requestInProcess(true);

        this.timeFormatting();
        this.userDataService.editBlockout(this.userID,
            this.availabilityBlock)
            .subscribe((res: any) => {
                if (res.status === 204) {
                    // UI Notification
                    this.interpreter.availability_blocks_attributes.filter(o => o.id === this.availabilityBlock.id)
                        .map(o => o = this.availabilityBlock);
                    this.spinnerService.requestInProcess(false);
                    this.notificationServiceBus.launchNotification(false, 'Blockout successfully updated');
                    this._location.back();
                }
            }, errors => {
                this.spinnerService.requestInProcess(false);
                let e = errors.json();
                this.notificationServiceBus.launchNotification(true, e);
            });
    }
    editStaffAvailabilities(form: FormGroup) {
        if (form.invalid) {
            this.notificationServiceBus.launchNotification(true, GLOBAL.MISSING_FIELDS_ERROR_MESSAGE);
            return;
        }
        this.spinnerService.requestInProcess(true);
        this.timeFormatting();
        this.userDataService.editStaffAvailabilities(this.userID,
            this.availabilityBlock)
            .subscribe((res: any) => {
                if (res.status === 204) {
                    // UI Notification
                    this.interpreter.staff_availabilities_attributes.filter(o => o.id === this.availabilityBlock.id)
                        .map(o => o = this.availabilityBlock);
                    this.spinnerService.requestInProcess(false);
                    this.notificationServiceBus.launchNotification(false, 'Staff-Availability successfully updated');
                    this._location.back();
                }
            }, errors => {
                this.spinnerService.requestInProcess(false);

                let e = errors.json();
                this.notificationServiceBus.launchNotification(true, e);
            });
    }

    saveBlockouts(form: any) {
        if (form.invalid) {
            this.validateAllFormFields(form.control);
        }
        if (this.availabilityBlock.id < 1) {
            this.addBlockouts(form);
        } else {
            if (this.staff_availability) {
                this.editStaffAvailabilities(form);
            } else {
                this.editBlockouts(form);
            }
        }
    }

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
              control.markAsTouched({ onlySelf: true });
            } else if (control instanceof FormGroup) {
              this.validateAllFormFields(control);
            }
          });
        }

    addBlockouts(form: FormGroup) {
        if (form.invalid) {
            this.notificationServiceBus.launchNotification(true, GLOBAL.MISSING_FIELDS_ERROR_MESSAGE);
            return;
        }
        this.timeFormatting();
        if (this.availabilityBlock.recurring) {
            this.setRecurring_week_days();
            if (this.availabilityBlock.frequency === 'weekly' && this.availabilityBlock.recurring_week_days.length === 0) {
                this.notificationServiceBus.launchNotification(true, GLOBAL.MISSING_FIELDS_ERROR_MESSAGE);
                return;
            } else if (this.availabilityBlock.frequency === 'daily') {
                this.availabilityBlock.recurring_week_days = [];
            }
        }
        this.spinnerService.requestInProcess(true);
        delete this.availabilityBlock.booking_id;
        if (this.staff_availability) {
            this.addStaffAvailabilitie(this.availabilityBlock);
        } else {
            this.userDataService.addBlockout(this.userID, this.availabilityBlock)
                .subscribe((res: any) => {
                    if (res.status === 200) {
                        // UI Notification

                        this.availabilityBlock.id = res.json().id;
                        this.spinnerService.requestInProcess(false);
                        this.interpreter.availability_blocks_attributes.push(this.availabilityBlock);
                        this.notificationServiceBus.launchNotification(false, 'Blockout successfully added');
                        this._location.back();

                    }
                }, errors => {
                    this.spinnerService.requestInProcess(false);

                    let e = errors.json();
                    this.notificationServiceBus.launchNotification(true, e);
                });
        }
    }
    addStaffAvailabilitie(staffAvailabilitieForm) {
        this.userDataService.addStaffAvailabilities(this.userID, this.availabilityBlock)
            .subscribe((res: any) => {
                if (res.status === 200) {
                    this.availabilityBlock.id = res.json().id;
                    this.spinnerService.requestInProcess(false);
                    this.interpreter.staff_availabilities_attributes.push(this.availabilityBlock);
                    this.notificationServiceBus.launchNotification(false, 'Staff Availability successfully added');
                    this._location.back();

                }
            }, errors => {
                this.spinnerService.requestInProcess(false);

                let e = errors.json();
                if (this.start_time.getTime() > this.end_time.getTime()) {
                    this.notificationServiceBus.launchNotification(true, 'End time cannot be before start time. Please change');
                } else {
                    this.notificationServiceBus.launchNotification(true, e);
                }
            });
    }

    timeFormatting() {
        let startDate = this.datePipe.transform(this.start_time, 'yyyy-MM-dd');
        let startTime = moment(this.start_time, 'hh:mm A').format('HH:mm:ss');
        let endTime = moment(this.end_time, 'hh:mm A').format('HH:mm:ss');
        let daylightSavings = this.interpreterDaylightSavings(startDate);
        let endDate;
        if (!this.availabilityBlock.recurring) {
            endDate = this.datePipe.transform(this.start_time, 'yyyy-MM-dd');
        } else {
            endDate = this.datePipe.transform(this.end_date, 'yyyy-MM-dd');
        }

        this.availabilityBlock.start_time = startDate + 'T' + startTime + daylightSavings;
        this.availabilityBlock.end_time = startDate + 'T' + endTime + daylightSavings;
        this.availabilityBlock.end_date = endDate;
    }
    settingTime() {
        let endTime = this.interpreterStateTimeZone(this.availabilityBlock.end_time);
        let currentDate = new Date();
        let sTime = this.interpreterStateTimeZone(this.availabilityBlock.start_time);
        let startDate = new Date(this.availabilityBlock.start_time);

        this.start_time = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(),
            moment.duration(sTime).get('hours'), moment.duration(sTime).get('minutes'));

        this.end_time = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(),
            moment.duration(endTime).get('hours'), moment.duration(endTime).get('minutes'));
        this.end_date = Boolean(this.availabilityBlock.end_date) ? new Date(this.availabilityBlock.end_date) :
            new Date(this.availabilityBlock.start_time);
    }
    interpreterDaylightSavings(startDate) {
        let timeZone = Booking.getNamedTimeZone(this.interpreter.address_attributes.state, this.interpreter.address_attributes.post_code.toString());
        return momentTimeZone(startDate).tz(timeZone).format('Z');
    }
    isEndDateGreterthenTostartDate(startDate, endDate) {
        let sDate = new Date(startDate).getDate();
        let sMonth = new Date(startDate).getMonth();
        let sYear = new Date(startDate).getFullYear();

        let eDate = new Date(endDate).getDate();
        let eMonth = new Date(endDate).getMonth();
        let eYear = new Date(endDate).getFullYear();
        let dateDiff = (+new Date(eYear + '-' + eMonth + '-' + eDate) - (+new Date(sYear + '-' + sMonth + '-' + sDate)));   // '+' is converting date to milliseconds
        return (dateDiff < 0) ? true : false;
    }
    checkMe(event) {
        this.dummy_time = event.target.value;
    }

    assignMe(timeControl, event) {
        if (event) {
            this.dummy_time = event.target.value;
        }
        if (timeControl === 'startTimeControl') {
            let temp = this.dummy_time.split(' ');
            this.dummy_time = this.dummy_time.replace(/\s/g, '');
            let strt_date = temp[0];
            if (temp[0].length !== 10) {
                return;
            }
            strt_date = strt_date.split('/');
            if (strt_date.length !== 3 || +strt_date[1] > 12) {
                this.start_time = null;
                return;
            }
            if (+strt_date[0] > 31) {
                this.start_time = null;
                return;
            }
            let str;
            this.dummy_time = this.dummy_time.substring(10, 17);
            let bookingTime = this.correctTimeFormat(this.dummy_time, timeControl);
            if (bookingTime) {
                if (isNaN(Date.parse(strt_date + ' ' + bookingTime))) {
                    bookingTime = strt_date[1] + '/' + strt_date[0] + '/' + strt_date[2] + ' ' + bookingTime;
                    if (isNaN(Date.parse(bookingTime)) ) {
                        this.dummy_time = this.start_time = this.end_time = null;
                        return;
                    }
                } else {
                    bookingTime = strt_date[1] + '/' + strt_date[0] + '/' + strt_date[2] + ' ' + bookingTime;
                }
                this.start_time = new Date(bookingTime);
                this.start_time.setSeconds(0);
                this.start_time.setMilliseconds(0);

            } else {
                this.start_time = this.end_time =  this.dummy_time = null;
            }
        } else {
            this.dummy_time = this.dummy_time.replace(/\s/g, '');
            let bookingTime = this.correctTimeFormat(this.dummy_time, timeControl);
            if (bookingTime) {
                let hr = bookingTime.split(':')[0];
                let mint = bookingTime.split(':')[1];
                let date = new Date();
                date.setHours(+hr);
                date.setMinutes(+mint.replace(' 00', ''));
                date.setSeconds(0);
                date.setMilliseconds(0);

                this.end_time = date;
            } else {
                this.end_time = this.dummy_time = null;
            }
        }

    }
    correctTimeFormat(time, controle) {
        let hh;
        let mm;
        let amPm;
        this.dummy_time = time.replace(/\s/g, '');
        let regularExpression = new RegExp('^([0-9]|0[0-9]|1[0-2]):([0-5][0-9])\s*?([AP]M)?$', 'i');
        let res = regularExpression.exec(time);
        let bookingTime;
        if (res) {
            hh = res[1];
            mm = res[2];
            amPm = res[3];
            if ((+mm) % 5 !== 0) {
                let temp_mm = (+mm) % 5;
                mm = ((+mm) + (5 - temp_mm)).toString();
                if (+mm === 60) {
                    mm = '00';
                    hh = (+hh + 1).toString();
                }
            }
            let hour;
            if (+hh < 10) {
                hour = '0' + hh;
            } else {
                hour = hh;
            }
            if (amPm) {
                amPm = amPm.toLocaleUpperCase();
            } else {
                amPm = 'AM';
            }
            if (controle === 'endTimeControl') {
                if (amPm === 'PM' && +hour !== 12) {
                    hour = (+hour) + 12;
                }
                return bookingTime = hour + ':' + mm + ' 00';
            } else {
                return bookingTime = hour + ':' + mm + ' ' + amPm;
            }
        }
    return false;
    }
    interpreterStateDateZone(datetime) {
        let timeZone = Booking.getNamedTimeZone(this.interpreter.address_attributes.state, this.interpreter.address_attributes.post_code.toString());
        return momentTimeZone(datetime).tz(timeZone);
    }
}



// WEBPACK FOOTER //
// ./src/app/user-management/user-profile/blockout/blockout.component.ts